import script from "./RichTextFormatMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./RichTextFormatMenu.vue?vue&type=script&setup=true&lang=js"

import "./RichTextFormatMenu.vue?vue&type=style&index=0&id=41d67c90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41d67c90"]])

export default __exports__